import { useState } from 'react';
import { CalendarDays, Check, Plus } from 'lucide-react';
import { TipoAlvo, TipoAtividade, formatarDiaMes } from '@nexital/shared';
import { linhaDoTempo } from '../../domain/licitacao';
import { useLicitacao } from './contexto';
import { DialogoAtividade } from './DialogoAtividade';
import { Modulo } from './Modulo';
import { PontaItem, atributosAlvo } from './PontaItem';

/** Lista vazia fixa: o seletor do store não pode devolver uma lista nova a cada leitura (laço infinito no React). */
const NENHUM: never[] = [];

/** Margem lateral da linha, em %, para os rótulos das pontas não serem cortados. */
const MARGEM = 6;
const naLinha = (posicao: number) => `${MARGEM + posicao * (100 - 2 * MARGEM)}%`;
const mesAno = (data: Date) => data.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
const hora = (iso: string) => new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

/** "Cronograma" (RQ-LIC-004): o planejado, com os marcos e o dia de hoje na mesma linha. */
export function ModuloCronograma() {
  const atividades = useLicitacao((s) => s.dados?.atividades ?? NENHUM);
  const [novo, definirNovo] = useState(false);
  const agora = new Date();
  const { marcos, hoje } = linhaDoTempo(atividades, agora);
  const hojeVisivel = hoje !== null && hoje >= 0 && hoje <= 1;
  const extra = <span className="modulo__contador">{mesAno(agora)}</span>;
  const acoes = (
    <button type="button" className="botao-icone" onClick={() => definirNovo(true)} aria-label="Adicionar marco">
      <Plus size={18} />
    </button>
  );
  return (
    <Modulo titulo="Cronograma" Icone={CalendarDays} cor="branco" extra={extra} acoes={acoes}>
      {marcos.length ? (
        <div className="cronograma" role="list">
          <span className="cronograma__linha" aria-hidden />
          {hojeVisivel && (
            <span className="cronograma__hoje" style={{ left: naLinha(hoje) }}>
              Hoje, {formatarDiaMes(agora)}
            </span>
          )}
          {marcos.map((m) => (
            <div
              key={m.uuid}
              role="listitem"
              className={`marco${m.concluidaEm ? ' marco--feito' : ''}`}
              style={{ left: naLinha(m.posicao) }}
              {...atributosAlvo(TipoAlvo.Atividade, m.uuid)}
            >
              <PontaItem uuid={m.uuid} />
              <span className="marco__data">{formatarDiaMes(m.prazo!)} • {hora(m.prazo!)}</span>
              <span className="marco__ponto" aria-hidden>{m.concluidaEm && <Check size={12} />}</span>
              <span className="marco__titulo">{m.titulo}</span>
            </div>
          ))}
        </div>
      ) : (
        <p className="modulo__vazio">Sem marcos ainda. Adicione a abertura, a sessão pública e os outros prazos.</p>
      )}
      {novo && <DialogoAtividade tipo={TipoAtividade.Marco} fechar={() => definirNovo(false)} />}
    </Modulo>
  );
}
